"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskContextProvider = exports.TaskContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var defaults_1 = require("./defaults");
var states_1 = require("./states");
var useLocalStorage_1 = require("../hooks/useLocalStorage");
var index_1 = require("./index");
var tasks_1 = require("./../../services/tasks");
var task_notes_1 = require("../../services/task_notes");
var user_1 = require("./user");
exports.TaskContext = (0, react_1.createContext)({
    task: defaults_1.defaultConfig.task,
    fetchTask: defaults_1.defaultConfig.fetchTask,
    updateTask: defaults_1.defaultConfig.updateTask,
    updateTaskStatus: defaults_1.defaultConfig.updateTaskStatus,
    createTaskNote: defaults_1.defaultConfig.createTaskNote,
    updateTaskNote: defaults_1.defaultConfig.updateTaskNote,
    deleteTaskNote: defaults_1.defaultConfig.deleteTaskNote,
});
var TaskContextProvider = function (_a) {
    var children = _a.children, defaults = _a.defaults, apiUrl = _a.apiUrl, ssrHydration = _a.ssrHydration;
    var token = (0, react_1.useContext)(user_1.UserContext).token;
    var abortControllers = (0, react_1.useRef)({});
    var _b = (0, useLocalStorage_1.useLocalStorage)("lms", "task", (0, index_1.getDefaultData)("task", __assign(__assign({}, defaults_1.defaultConfig), defaults)), ssrHydration), task = _b[0], setTask = _b[1];
    var fetchTask = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "task".concat(id),
                id: id,
                mode: "value",
                fetchAction: tasks_1.getTask.bind(null, apiUrl)(token, id, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["task".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setTask,
            })
            : Promise.reject("noToken");
    }, [token]);
    var updateTask = (0, react_1.useCallback)(
    // TODO: update task on list and byID once it fine
    // TODO: what about error ?
    function (id, data) {
        return token
            ? (0, tasks_1.updateTask)(apiUrl, token, id, data)
            : Promise.reject("noToken");
    }, [token]);
    var updateTaskStatus = (0, react_1.useCallback)(
    // TODO: update task on list and byID once it fine
    // TODO: what about error ?
    function (id, done) {
        if (done === void 0) { done = true; }
        if (!token) {
            return Promise.reject("noToken");
        }
        return done
            ? (0, tasks_1.completeTask)(apiUrl, token, id)
            : (0, tasks_1.incompleteTask)(apiUrl, token, id);
    }, [token]);
    var createTaskNote = (0, react_1.useCallback)(
    // TODO: update task on list and byID once it fine
    // TODO: what about error ?
    function (id, note) {
        if (!token) {
            return Promise.reject("noToken");
        }
        return (0, task_notes_1.createTaskNote)(apiUrl, token, {
            task_id: id,
            note: note,
        });
    }, [token]);
    var updateTaskNote = (0, react_1.useCallback)(
    // TODO: update task on list and byID once it fine
    // TODO: what about error ?
    function (taskId, taskNoteId, note) {
        if (!token) {
            return Promise.reject("noToken");
        }
        return (0, task_notes_1.updateTaskNote)(apiUrl, token, taskNoteId, {
            task_id: taskId,
            note: note,
        });
    }, [token]);
    var deleteTaskNote = (0, react_1.useCallback)(
    // TODO: update task on list and byID once it fine
    // TODO: what about error ?
    function (taskNoteId) {
        if (!token) {
            return Promise.reject("noToken");
        }
        return (0, task_notes_1.deleteTaskNote)(apiUrl, token, taskNoteId);
    }, [token]);
    return ((0, jsx_runtime_1.jsx)(exports.TaskContext.Provider, __assign({ value: {
            task: task,
            fetchTask: fetchTask,
            updateTask: updateTask,
            updateTaskStatus: updateTaskStatus,
            createTaskNote: createTaskNote,
            updateTaskNote: updateTaskNote,
            deleteTaskNote: deleteTaskNote,
        } }, { children: children })));
};
exports.TaskContextProvider = TaskContextProvider;
